module.exports = __webpack_public_path__ + "static/cercazone_hero4-9d0208b5d4532ccd2eef23bf39a5d908.jpg";